export const DEFAULT_PER_RETURN_BILLING_FEE = 1.5;

/**
 * Keep in sync with the generated `PerReturnBillingSettingsRaw` in
 * redo/backend/db/schema/src/types/team/PerReturnBillingSettings.schema.d.ts.
 */
export interface PerReturnBillingSettings {
  enabled: boolean;
  usageFee: number;
}
